import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function SalesLetterHero() {
  return <section className="relative min-h-screen w-full overflow-hidden bg-gradient-to-b from-[#0a0e27] via-[#1a1a4e] to-[#2d1b69] py-16 px-4 md:py-24" data-id="element-166">
      {/* Stars background */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-167">
        {[...Array(50)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-white rounded-full opacity-40" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 3}s`
      }} data-id="element-168" />)}
      </div>

      {/* Glowing orb effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a853] rounded-full opacity-5 blur-[120px]" data-id="element-169" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-170">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-171">
          {/* Book Cover */}
          <motion.div initial={{
          opacity: 0,
          x: -50,
          rotate: -5
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: -3
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex-shrink-0" data-id="element-172">
            <div className="relative" data-id="element-173">
              {/* Glow effect behind book */}
              <div className="absolute inset-0 bg-[#d4a853] rounded-lg opacity-20 blur-2xl transform scale-110" data-id="element-174" />
              <img src="https://cdn.magicpatterns.com/uploads/9tXLN6qwFxiyFL1aSBKPLY/ADAPTADA.png" alt="Activa tu intuición y transforma tu vida con las 7 Leyes Universales - Portada del eBook" className="relative w-64 md:w-80 lg:w-96 rounded-lg shadow-2xl shadow-[#d4a853]/30 transform hover:rotate-0 transition-transform duration-500" data-id="element-175" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="text-center lg:text-left" data-id="element-176">
            <h1 className="font-playfair text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#d4a853] leading-tight mb-6" data-id="element-177">
              Activa tu intuición y transforma tu vida con las 7 Leyes
              Universales
            </h1>

            <p className="font-dm-sans text-lg md:text-xl lg:text-2xl text-[#f5f0e8]/90 mb-4 leading-relaxed" data-id="element-178">
              Reprograma tu mente, cambia tus creencias y crea resultados reales
              en tu día a día
            </p>

            <p className="font-playfair text-xl md:text-2xl text-[#f0c75e] italic mb-8" data-id="element-179">
              Autor: Gustavo Rodríguez
            </p>

            <motion.a href="#cta" onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            document.getElementById('cta')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center gap-3 bg-gradient-to-r from-[#d4a853] to-[#f0c75e] text-[#0a0e27] font-dm-sans font-bold text-lg md:text-xl px-8 py-4 rounded-full shadow-lg shadow-[#d4a853]/40 hover:shadow-[#d4a853]/60 transition-shadow" data-id="element-180">
              Quiero transformar mi vida
              <ArrowRightIcon className="w-5 h-5" data-id="element-181" />
            </motion.a>
          </motion.div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#2d1b69] to-transparent" data-id="element-182" />
    </section>;
}